import { IProduct } from "./product";

export interface IPartner {
  cpf: string;
  name: string;
  email?: string | null;
  phone?: string | null;
  representanteLegal: boolean;
  recommendation: string;
  creditCardLimit?: number;
}

export interface IHistory {
  companyName: string;
  partners: IPartner[];
  recommendation: string;
  data: string;
  startDate: string;
  endDate: string;
  document: string;
  status: number;
  protocol?: string;
  addresses?: AddressDTO[];
  emails?: EmailDTO[];
  professionalDataPF?: ProfessionalDataPFDTO[];
  relatedesPF?: RelatedPFDTO[];
  clusterData?: string;
  score?: string;
  clusterDataPartners?: string;
  creditCardLimit?: number;
  valueScore4Axon?: string;
  valueTagRecomendacao?: string;
  valueTagClusterDadosCPF?: string;
  valueTagBiometria?: string;
  valueTagClusterDadosCNPJ?: string;
  valueTagClusterDadosCombinado?: string;
  phoneDistinct?: string;
  allowMeDocumentResult: any;
  allowMeDeviceValidationResult: any;
  allowMeLivenessResult: any;
  consultationDataPH3A: any
}
export interface RelatedPFDTO {
  type: number;
  isPep: boolean;
  isVip: boolean;
  name: string;
  gender: number;
  document: number;
  documentType: number;
  documentFormatted: string;
  ranking: number;
  createDate: string;
  status: number;
}

export interface AddressDTO {
  street: string;
  number: string;
  complement?: any;
  district: string;
  zipCode: number;
  city: string;
  type: string;
  title?: string;
  state: string;
  dneId: number;
  ibge: number;
  censusSector: number;
  geolocation?: any;
  borders?: any;
  isFiscalAddress: boolean;
  complementFormatted?: string;
  alias: string;
  shortAlias: string;
  companyDocument: number;
  companyName?: string;
  score: number;
  ranking: number;
  createDate: string;
  status: number;
}

export interface PhoneDTO {
  areaCode: number;
  number: number;
  formattedNumber: string;
  operatorId: number;
  operator: string;
  isFacebook: boolean;
  isWhatsapp: boolean;
  isProcon: boolean;
  isMobile: boolean;
  installationDate?: string | null;
  removalDate?: string | null;
  ranking: number;
  createDate: string;
  status: number;
}
export interface ProfessionalDataPFDTO {
  demissionDate?: string;
  company: ProfessionalCompanyDTO;
  elapsedDays: number;
  description?: string;
  ranking: number;
  createDate: string;
  status: number;
}
export interface EmailDTO {
  email: string;
  isValidated: boolean;
  isFacebook: boolean;
  isLinkedIn: boolean;
  isDigitalBehavior: boolean;
  isFromPartner: boolean;
  domain: string;
  score: number;
  ranking: number;
  createDate: string;
  status: number;
}
export interface FiscalSituationPFDTO {
  condition: number;
  checkCode: string;
  deathYear: number;
  checkDate: string;
  description: string;
  ranking: number;
  createDate: string;
  status: number;
}
export interface ProfessionalCompanyDTO {
  taxModel: number;
  businessSize: number;
  businessSizeOriginal?: any;
  optingSimple: boolean;
  isMEI: boolean;
  legalNatureId: number;
  totalEmployees: number;
  totalCompanies: number;
  totalPartners: number;
  totalCompanyPartners: number;
  mainCompanyDocument?: any;
  legalNature?: any;
  cnae: number;
  size: number;
  name: string;
  gender: number;
  document: number;
  documentType: number;
  documentFormatted: string;
  ranking: number;
  createDate?: string;
  status: number;
}

export enum EnumStatusConsultation {
  approved = 0,
  disapproved = 1,
  inProcess = 2,
  completed = 3,
  inAnalyzing = 4,
}
